import type { ShiftMark } from '@krp/sale-ui'

import type { AgentSessionModel } from '../../agent-session/model/agentSessionController'

/**
 * Что колонка расчёта берёт у источника «Собственная»: смена и где работаем. Чистые функции от модели сессии агента: ничего не
 * читают и не отправляют. Связь собственной кассы сигналами точки «Связь» — `registerHealth.ts` (RP-UI-LINK).
 */

/** Смена для строки «● Смена открыта»: истекшая смена — закрытая (продавать в ней нельзя); не прочитана — «не подтверждено». */
export function shiftMarkOf(session: Pick<AgentSessionModel, 'device' | 'deviceUnreachable'>): ShiftMark {
  if (session.deviceUnreachable || session.device === null) return 'unknown'
  switch (session.device.shift?.state) {
    case 'opened':
      return 'open'
    case 'closed':
    case 'expired':
      return 'closed'
    default:
      return 'unknown'
  }
}

/** «Этот компьютер · касса АТОЛ»: где работаем. Имя компьютера — из ответа агента, если он его отдаёт. */
export function tillWhere(session: Pick<AgentSessionModel, 'agent'>): string {
  const machine = session.agent?.hello.host?.machine ?? null
  return ['Этот компьютер', machine, 'касса и терминал'].filter((part) => part !== null && part !== '').join(' · ')
}
